import { Modal } from 'foundations-components/transitional/components/Modal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { List } from 'foundations-components/transitional/components/List';
import { H1 } from 'foundations-components/transitional/components/H1';
import { View } from 'foundations-components/transitional/components/View';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProgressTransferConfirmationModal = ({
  certificates,
  closeModal,
  destinationEmail,
  error,
  loading,
  onConfirm,
  sourceEmail,
  trackEvent,
  ErrorComponent
}) => {
  const handleSubmit = () => {
    trackEvent({
      action: 'certswap-request-confirmed'
    });
    onConfirm();
  };
  const renderModalContent = () => {
    if (error) {
      return /*#__PURE__*/_jsx(ErrorComponent, {
        error: error
      });
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(H1, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.transferConfirmationModal.title"
          })
        }), /*#__PURE__*/_jsxs(View, {
          textAlign: "left",
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "learningCenter.myTeam.transferConfirmationModal.body",
            options: {
              destinationEmail,
              sourceEmail
            }
          }), /*#__PURE__*/_jsx(List, {
            styled: true,
            wrapChildren: true,
            children: certificates
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "400",
            children: /*#__PURE__*/_jsx("strong", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.myTeam.transferConfirmationModal.warning"
              })
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        align: "center",
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": "progress-transfer-confirmation-modal-confirm-button",
          loading: loading,
          onClick: handleSubmit,
          onLoadingFinish: closeModal,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.transferConfirmationModal.confirmButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "progress-transfer-confirmation-modal-cancel-button",
          onClick: closeModal,
          use: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.myTeam.transferConfirmationModal.cancelButton"
          })
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "progress-transfer-confirmation-modal",
    use: "conversational",
    width: 550,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      })
    }), renderModalContent()]
  });
};
export default ProgressTransferConfirmationModal;